import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {AuthProvider} from '@/modules/auth/hooks/useAuth';
import {TenantProvider} from '@/shared/hooks/useTenant';
import {AppQueryProvider} from '@/shared/contexts/QueryProvider';
import {Provider} from 'react-redux';
import {store} from './store';
import ErrorBoundary from '@/shared/components/ErrorBoundary';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
    <React.StrictMode>
        <ErrorBoundary>
            <TenantProvider>
                <AppQueryProvider>
                    <AuthProvider initialCheckToken={true}>
                        <Provider store={store}>
                            <App />
                        </Provider>
                    </AuthProvider>
                </AppQueryProvider>
            </TenantProvider>
        </ErrorBoundary>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
